import { useGlobal } from '@/utils/useGlobal';
import { Modal } from 'antd';
import css from './questionmodal.module.scss';

export const defaultQuestionData = {
    title: 'Annotation',
    text: `The North Face's first Aconcagua already impressed us with lofty warmth worthy of yurt trips and winter walks through ski towns at night. Now back with even greater protection, the Men's Aconcagua 2 Hooded Jacket brings windproofing into the equation so you can stay our when the winds pick up. It still has the lofty down insulation mixed with synthetic insulation in key areas that would usually get damp in a snowstorm, as well as a DWR treatment to help shed moisture. The only difference is The North Face's WindWall shell for added windproofing.`,
};

export default function QuestionModal({ isShow = false, data = defaultQuestionData, callBack }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const [visible, setVisible] = useState(isShow);
    const { t } = useLang('shared');

    useEffect(() => {
        setVisible(isShow);
    }, [isShow]);

    const handleClose = () => {
        callBack(false);
    };

    return (
        <Modal width={644} centered closable={false} wrapClassName={css.calculatorsmm100step4questionModal} visible={visible}>
            <span className="questionModal-closeBtn" onClick={handleClose}>
                ×
            </span>
            <h1 className="questionModalTitle">
                {/* {data?.title} */}
                {t('calculators.mm100.step4.annotation')}
            </h1>
            <p className="questionModalText">{data?.text}</p>
        </Modal>
    );
}
